import React, { useCallback } from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineShareAltIcon from 'components/Luxkit/Icons/line/LineShareAltIcon'
import * as Analytics from 'analytics/analytics'
import IconButton from 'components/Luxkit/Button/IconButton'

interface Props extends Omit<React.ComponentProps<typeof TextButton>, | 'kind' | 'children'> {
  iconOnly?: boolean;
}

function ShareWithFriendsButton(props: Props) {
  const { onClick, iconOnly, ...rest } = props

  const onShareClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e)
    Analytics.trackClientEvent({
      subject: 'share',
      action: 'pressed',
      category: 'offer_page',
      type: 'interaction',
    })
  }, [onClick])

  if (iconOnly) {
    return <IconButton
      {...rest}
      size="medium"
      shape="circle"
      kind="secondary"
      variant="dark"
      onClick={onShareClick}
    >
      <LineShareAltIcon aria-hidden="true" />
    </IconButton>
  }

  return <TextButton
    kind="tertiary"
    {...rest}
    startIcon={<LineShareAltIcon aria-hidden="true" />}
    onClick={onShareClick}
  >
    Share
  </TextButton>
}

export default ShareWithFriendsButton
